// extracted by mini-css-extract-plugin
export var currencyInput = "_jy-1";
export var currencySymbol = "_jy-0";